const ResetIcon: React.FC = () => {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M31.9603 28.3205L28.6103 28.6505L28.2803 25.3105" stroke="white" stroke-miterlimit="10" />
            <path
                d="M28.6901 28.4901C32.4301 24.5701 33.1601 18.4701 30.1001 13.7201C26.5101 8.1501 19.0801 6.5401 13.5101 10.1301C7.94014 13.7201 6.33014 21.1501 9.92014 26.7201C10.3001 27.3101 10.7301 27.8601 11.1901 28.3701"
                stroke="white"
                stroke-miterlimit="10"
            />
            <path
                d="M18.3398 25.9492C18.8398 26.4992 19.3898 30.6892 15.5098 32.7092"
                stroke="white"
                stroke-miterlimit="10"
            />
            <path d="M24.49 32.7092C20.61 30.6892 21.16 26.4992 21.66 25.9492" stroke="white" stroke-miterlimit="10" />
            <path
                d="M15.71 32.71H24.3C25.4 32.71 26.3 33.61 26.3 34.71H13.71C13.71 33.61 14.61 32.71 15.71 32.71Z"
                stroke="white"
                stroke-miterlimit="10"
            />
            <path
                d="M19.9999 26.5096C21.5629 26.5096 22.8299 25.2426 22.8299 23.6796C22.8299 22.1166 21.5629 20.8496 19.9999 20.8496C18.437 20.8496 17.1699 22.1166 17.1699 23.6796C17.1699 25.2426 18.437 26.5096 19.9999 26.5096Z"
                stroke="white"
                stroke-miterlimit="10"
            />
        </svg>
    )
}

export default ResetIcon
